import * as React from 'react';
import { Tooltip } from 'antd';
import styles from './index.less';
import fTooltipStyles from '../FTooltip/index.less';
import { FI18n, FUtil } from '@freelog/tools-lib';

export enum EResourceStatusBadge {
  'unreleased' = 0,
  'online' = 1,
  'freeze' = 2,
  'offline' = 4,
}

interface FResourceStatusBadgeProps {
  style?: React.CSSProperties;
  status?: 'online' | 'offline' | 'unreleased' | 'freeze';
}

function FResourceStatusBadge({ status = 'online', style = {} }: FResourceStatusBadgeProps) {
  const refBadge = React.useRef<HTMLDivElement>(null);
  const [overflowTooltipEnabled, setOverflowTooltipEnabled] = React.useState(true);

  const [$statusTextObj, set$statusTextObj, get$statusTextObj] = FUtil.Hook.useGetState({
    online: FI18n.i18nNext.tAuto('filter_resource_status_availableforauth'),
    offline: FI18n.i18nNext.tAuto('filter_resource_status_pendingauth'),
    unreleased: FI18n.i18nNext.tAuto('filter_resource_status_prepareforrelease'),
    freeze: FI18n.i18nNext.tAuto('filter_resource_status_removedbyfreelog'),
  });

  if (status === 'online') {
    return null;
  }

  const statusText = $statusTextObj[status];

  return (
    <Tooltip
      title={<span className={fTooltipStyles.title}>{statusText}</span>}
      color="#fff"
      arrow={{ pointAtCenter: true }}
      placement="top"
      open={overflowTooltipEnabled ? undefined : false}
    >
      <div
        ref={refBadge}
        className={[styles.style, styles[status]].join(' ')}
        style={style}
        onMouseEnter={() => {
          requestAnimationFrame(() => {
            const el = refBadge.current;
            if (el) {
              setOverflowTooltipEnabled(el.scrollWidth > el.clientWidth);
            }
          });
        }}
        onMouseLeave={() => {
          setOverflowTooltipEnabled(true);
        }}
      >
        {statusText}
      </div>
    </Tooltip>
  );
}

export default FResourceStatusBadge;

export function resourceStatus_numberToText(
  status: number,
): NonNullable<FResourceStatusBadgeProps['status']> {
  return status === 2
    ? 'freeze'
    : status === 1
    ? 'online'
    : status === 0
    ? 'unreleased'
    : 'offline';
}
